/**
 * Constructor method for creating instance of an item within the sidebar
 *
 * Instance properties
 * - sidebarNav : reference to the controlling sidebarNav instance
 * - domNode : reference to domNode
 * - hasFocus : flag to identify current focus
 * - hasHover : flag to identify current hover
 *
 * @param {Node} domNode DomNode for the headerNavItem
 * @param {object} headerObj Instance of the controlling HeaderNav
 */

const SidebarNavItem = function (domNode, sidebarObj) {
  this.sidebarNav = sidebarObj;
  this.domNode = domNode;

  this.hasFocus = false;
  this.hasHover = false;

  this.keyCode = Object.freeze({
    TAB: 9,
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
  });
};

/*
 * Initializer for a SidebarNav instance
 *
 * Sets all listeners for the sidebarNavItem to handle keyboard navigation
 *
 */
SidebarNavItem.prototype.init = function () {
  this.domNode.tabIndex = -1;

  this.domNode.addEventListener("keydown", this.handleKeydown.bind(this));
};

SidebarNavItem.prototype.handleKeydown = function (event) {
  let tgt = event.currentTarget,
    flag = false;

  switch (event.keyCode) {
    case this.keyCode.SPACE:
    case this.keyCode.RETURN:
      // Create simulated mouse event to mimic the behavior of ATs
      // and let the event handler handleClick do the housekeeping.
      try {
        clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
      } catch (err) {
        if (document.createEvent) {
          // DOM Level 3 for IE 9+
          clickEvent = document.createEvent("MouseEvents");
          clickEvent.initEvent("click", true, true);
        }
      }
      tgt.dispatchEvent(clickEvent);

      flag = true;
      break;

    case this.keyCode.UP:
    case this.keyCode.LEFT:
      this.sidebarNav.setFocusToPreviousItem(this);
      flag = true;
      break;

    case this.keyCode.DOWN:
    case this.keyCode.RIGHT:
      this.sidebarNav.setFocusToNextItem(this);
      flag = true;
      break;

    case this.keyCode.HOME:
    case this.keyCode.PAGEUP:
      this.sidebarNav.setFocusToFirstItem();
      flag = true;
      break;

    case this.keyCode.END:
    case this.keyCode.PAGEDOWN:
      this.sidebarNav.setFocusToLastItem();
      flag = true;
      break;

    case this.keyCode.TAB:
      this.sidebarNav.close();
      break;

    case this.keyCode.ESC:
      this.sidebarNav.setFocusToClose(true);
      break;

    default:
      flag = true;
      break;
  }

  if (flag) {
    event.stopPropagation();
    event.preventDefault();
  }
};
